import React from "react";
import { motion } from "framer-motion";
import { useLang } from "@/i18n";
import { DotGrid, BarsMark } from "@/components/site/Marks";
import Poem from "@/components/site/Poem";

const About = () => {
  const { t } = useLang();
  return (
    <section id="about" className="relative py-24 md:py-36 px-6 md:px-10">
      <div className="max-w-[1400px] mx-auto grid lg:grid-cols-12 gap-12 lg:gap-16 items-center">
        <motion.div
          initial={{ opacity: 0, scale: 1.04 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 1 }}
          className="lg:col-span-5 relative"
        >
          <div className="relative overflow-hidden">
            <img
              src={`${process.env.REACT_APP_BACKEND_URL}/api/files/portrait-e3247bbd-3966-4285-8a84-24a471a63190.jpg`}
              alt="Marián Hriňa — autoportrét"
              data-testid="about-portrait"
              className="w-full h-auto object-cover"
              style={{ filter: "saturate(0.82) contrast(1.05) brightness(0.97)" }}
            />
            {/* warm tint to harmonise with the page palette */}
            <div
              className="absolute inset-0 pointer-events-none mix-blend-soft-light"
              style={{ background: "linear-gradient(135deg, rgba(217,121,37,0.4) 0%, rgba(176,36,24,0.18) 55%, rgba(5,5,5,0) 100%)" }}
            />
            {/* fade into the dark background */}
            <div
              className="absolute inset-0 pointer-events-none"
              style={{ background: "linear-gradient(to top, rgba(5,5,5,0.92) 0%, rgba(5,5,5,0.15) 38%, rgba(5,5,5,0) 70%)" }}
            />
          </div>
          <div
            className="absolute -inset-6 -z-10"
            style={{ background: "radial-gradient(60% 60% at 50% 50%, rgba(217,121,37,0.16), rgba(5,5,5,0))" }}
          />
        </motion.div>

        <div className="lg:col-span-7 lg:pl-8 relative">
          <DotGrid className="absolute -top-4 right-0 opacity-30 hidden md:block" color="#d97925" cols={5} rows={4} gap={10} />
          <p className="overline text-[#d97925] mb-5">{t("about.overline")}</p>
          <h2 className="font-serif-display font-light text-5xl md:text-6xl lg:text-7xl tracking-tight leading-[0.95]">
            {t("about.title")}
          </h2>
          <div className="mt-8 space-y-6 max-w-xl text-[#a3a09a] text-lg leading-relaxed font-light">
            <p data-testid="about-p1">{t("about.p1")}</p>
            <p data-testid="about-p2">{t("about.p2")}</p>
          </div>
          <blockquote
            data-testid="about-quote"
            className="mt-10 border-l-2 border-[#b02418] pl-6 font-serif-display italic text-2xl md:text-3xl text-[#f5f2eb] leading-snug max-w-xl"
          >
            {t("about.quote")}
          </blockquote>
          <p className="mt-8 font-serif-display italic text-2xl text-[#d97925]">{t("about.signature")}</p>
          <BarsMark className="mt-6 opacity-40" color="#f5f2eb" count={3} w={32} />
        </div>
      </div>

      <Poem />
    </section>
  );
};

export default About;
